import React, { useCallback, memo, useState, useEffect } from "react";
import SmallLoader from "../../common/SmallLoader";
import { NumericFormat } from "react-number-format";
import { formatToDollar } from "../sections-quote/pricing-tool/utils/utils";
const Administrative = ({
  administrativeData,
  coastPeoChargesData,
  tableName,
  HeadingValue,
  setAdministrativeData,
  setAdministrativeCoastData,
  changePeoCharges,
  administrativeDataLoader,
  disabled,
}) => {
  const finalAdministrativeData = changePeoCharges
    ? coastPeoChargesData
    : administrativeData;
  const updateAdministrativeData = (
    questionId,
    value,
    isBackupUpdate = false
  ) => {
    if (changePeoCharges) {
      setAdministrativeCoastData(tableName, questionId, value, isBackupUpdate);
    } else {
      setAdministrativeData(tableName, questionId, value, isBackupUpdate);
    }
  };

  // const [checkedMap, setCheckedMap] = useState({}); // Removed unused state

  const [totalEmployees, settotalEmployees] = useState();

  const handleInputTextChange = (e, questionId, isIncluded) => {
    let { value } = e.target;
    value = value.replace(/[^0-9.]/g, ""); // Allow only numbers and decimal point
    value = value.replace(/(\..*)\./g, "$1"); // Allow only one decimal point
    value = value.replace(/^(\d+\.?\d{0,2}).*$/, "$1"); // Allow only two decimal places
    value = `$${value}`; // Append $ at the start
    updateAdministrativeData(questionId, value, isIncluded);
  };

  const handleInputNumberChange = (e, questionId, isIncluded) => {
    let { value } = e;
    value = Number(value);
    updateAdministrativeData(questionId, value, isIncluded);
  };

  const handleSelectTextChange = (e, questionId, isIncluded) => {
    let { value } = e.target;
    updateAdministrativeData(questionId, value, isIncluded);
  };

  const handleSelectNumberChange = (e, questionId, isIncluded) => {
    let { value } = e.target;
    value = value.replace(/[$,]/g, "");
    value = parseFloat(value);
    updateAdministrativeData(questionId, value, isIncluded);
  };

  const handlePepmCalculationChange = (value) => {
    const calcCharges = value?.calcCharges;

    if (calcCharges === "per_client") {
      const valueAmount = value?.response / totalEmployees;
      const finalPepm = valueAmount / 12;
      return finalPepm;
    }
    if (calcCharges === "per_employee") {
      const finalPepm = value?.response / 12;
      return finalPepm;
    }
  };
  const handleCheckboxChange = (questionId, currentResponse, backupValue) => {
    if (currentResponse === "Included") {
      updateAdministrativeData(questionId, backupValue || 0);
    } else {
      updateAdministrativeData(questionId, "Included");
    }
  };

  useEffect(() => {
    const currProspect = JSON.parse(sessionStorage.getItem("currProspect"));
    const childrenLoc = currProspect?.childrenLoc;
    let totalFT = 0;
    let totalPT = 0;

    Object.values(childrenLoc).forEach((location) => {
      Object.values(location.classCodesInfo || {}).forEach((classCode) => {
        totalFT += Number(classCode?.ft?.value || 0);
        totalPT += Number(classCode?.pt?.value || 0);
      });
    });

    const totalEmployees = totalFT + totalPT;
    if (totalEmployees) {
      settotalEmployees(totalEmployees);
    }
    // childrenLoc.map((data) => {
    console.log(totalEmployees, "totalEmployees");
    // });
  }, []);

  return (
    <div className="mt-5 mb-5">
      <h2
        style={{ color: "#A33336", fontWeight: "700", marginLeft: "18px" }}
        className=" mb-4 mt-2"
      >
        {HeadingValue}
      </h2>
      {
        <div className="container">
          {tableName === "administrativeServicekey" && (
            <div>
              <div className="row me-auto">
                <div className="col-auto pe-0">
                  <div
                    className="d-flex checkbox-styles justify-content-center mt-2"
                    style={{ visibility: "hidden" }}
                  >
                    <input type="checkbox" className="no-border-checkbox" />
                  </div>
                </div>
                <div className="col-md-2">
                  <p className="bold-text text-center">PEPM</p>
                </div>
                <div className="col-md-2">
                  <p className="bold-text text-center">Annual charges</p>
                </div>
                <div className="col"></div>
              </div>
            </div>
          )}
          {finalAdministrativeData &&
            Object.keys(finalAdministrativeData).length > 0 &&
            Object.values(finalAdministrativeData).map((value, index) => (
              <div key={index} className="row  me-auto my-1 peoChargesRow">
                <div className="col-auto text-center pe-0">
                  <div className="d-flex checkbox-styles justify-content-center mt-2">
                    <input
                      type="checkbox"
                      checked={value?.response === "Included"}
                      onChange={() =>
                        handleCheckboxChange(
                          value?.questionId,
                          value?.response,
                          value?.backupValue
                        )
                      }
                      className="no-border-checkbox"
                      disabled={
                        (typeof value?.response === "string" &&
                          value?.response !== "Included") ||
                        value?.calcCharges === null ||
                        value?.calcCharges === undefined
                      }
                    />
                  </div>
                </div>

                <div className="col-md-2">
                  {value?.response === "Included" ? (
                    <div
                      className="form-control text-center"
                      style={{ fontSize: "14px" }}
                    >
                      Included
                    </div>
                  ) : typeof value?.response === "string" ||
                    value?.calcCharges === null ||
                    value?.calcCharges === undefined ? (
                    <input
                      readOnly={true}
                      type="text"
                      className="form-control"
                      value="-"
                      style={{
                        width: "100%",
                        // padding: "3px 21px",
                        fontSize: "14px",
                        textAlign: "center",
                        pointerEvents: "none",
                      }}
                    />
                  ) : (
                    <NumericFormat
                      readOnly={true}
                      type="text"
                      className="form-control"
                      style={{
                        width: "100%",
                        fontSize: "14px",
                        textAlign: "center",
                        pointerEvents: "none",
                      }}
                      prefix={"$"}
                      decimalScale={2}
                      allowNegative={false}
                      fixedDecimalScale
                      value={
                        value?.calcCharges === "same_response"
                          ? value?.response
                          : handlePepmCalculationChange(value)
                      }
                    />
                  )}
                </div>

                <div className="col-md-2 ">
                  {value?.dropDown === "yes" ? (
                    typeof (value?.response === "Included"
                      ? value?.backupValue
                      : value.response) === "string" ? (
                      <select
                        disabled={disabled}
                        className="form-select"
                        style={{
                          width: "100%",
                          // padding: "2px 20px",
                          fontSize: "14px",
                          textAlign: "center",
                          textTransform: "capitalize",
                        }}
                        value={
                          value?.response === "Included"
                            ? value?.backupValue
                            : value?.response
                        }
                        onChange={(e) =>
                          handleSelectTextChange(
                            e,
                            value?.questionId,
                            value?.response === "Included"
                          )
                        }
                      >
                        {value?.options.map((option, index) => (
                          <option
                            key={index}
                            style={{ textTransform: "capitalize" }}
                          >
                            {option}
                          </option>
                        ))}
                      </select>
                    ) : (
                      <select
                        disabled={disabled}
                        className="form-select"
                        style={{
                          width: "100%",
                          // padding: "2px 20px",
                          fontSize: "14px",
                          textAlign: "center",
                        }}
                        value={formatToDollar(
                          value?.response === "Included"
                            ? value?.backupValue
                            : value?.response
                        )}
                        onChange={(e) =>
                          handleSelectNumberChange(
                            e,
                            value?.questionId,
                            value?.response === "Included"
                          )
                        }
                      >
                        {value?.options.map((option, index) => (
                          <option key={index}>{formatToDollar(option)}</option>
                        ))}
                      </select>
                    )
                  ) : typeof (value?.response === "Included"
                      ? value?.backupValue
                      : value.response) === "string" ? (
                    <input
                      disabled={disabled}
                      type="text"
                      className="form-control"
                      style={{
                        width: "100%",
                        fontSize: "14px",
                        textAlign: "center",
                        textTransform: "capitalize",
                      }}
                      value={`${
                        value?.response === "Included"
                          ? value?.backupValue
                          : value?.response
                      }`}
                      onChange={(e) =>
                        handleInputTextChange(
                          e,
                          value?.questionId,
                          value?.response === "Included"
                        )
                      }
                    />
                  ) : (
                    <NumericFormat
                      disabled={disabled}
                      type="text"
                      className="form-control"
                      style={{
                        width: "100%",
                        fontSize: "14px",
                        textAlign: "center",
                      }}
                      prefix={"$"}
                      decimalScale={2}
                      allowNegative={false}
                      fixedDecimalScale
                      value={
                        value?.response === "Included"
                          ? value?.backupValue
                          : value?.response
                      }
                      onValueChange={(values, sourecInof) =>
                        handleInputNumberChange(
                          values,
                          value?.questionId,
                          value?.response === "Included"
                        )
                      }
                    />
                  )}
                </div>

                <div className="col-md-7">
                  <p
                    className="form-label  peoChargefont my-1 "
                    dangerouslySetInnerHTML={{ __html: value?.question }}
                  ></p>
                </div>
              </div>
            ))}
        </div>
      }
    </div>
  );
};

export default memo(Administrative);
